// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + "64bcc6aa" + "." + "c205702dba3b2862" + ".js";
};